module.exports = __webpack_public_path__ + "static/media/yes_promo.eed81a40.svg";